// extracted by mini-css-extract-plugin
export default {"TitleBox":"TitleBox_TitleBox__kPKBE"};